import { signal } from "@preact/signals-react";

import ModalReport from "componentsv2/modal/ModalReport";
import { Report } from "components/Icons";
import { layout as guestList } from "./reportGuestList";
import { layout as roomsOccupancy } from "./reportRoomsOccupancy";
import { layout as housekeeping } from "./reportHouseKeeping";
import { layout as operationForecast } from "./reportOperationForecast";

const base =
  "flex bg-white md:my-2 md:mx-4 px-4 py-2 shadow-lg h-24 w-full md:w-64 outline-neutral-400 cursor-pointer outline-2 outline-offset-4 rounded-xl border-1 border-dashed border-neutral-400 shadow-neutral-300 overflow-hidden active:scale-95 active:shadow-lg";

const currentReport = signal(null);
const openModal = signal(false);

function Reports({ onClick }) {
  const reports = [roomsOccupancy(), guestList(), housekeeping(), operationForecast()];

  function handleClick(report) {
    currentReport.value = report;
    openModal.value = true;
  }

  function closeModal() {
    openModal.value = false;
  }

  return (
    <div className="md:flex md:flex-wrap mt-10 max-md:space-y-6 max-md:px-5">
      {reports.map((report, idx) => (
        <div key={idx} className={base} onClick={() => handleClick(report)}>
          <div className="flex w-10">
            <Report className="h-7 w-7 my-auto text-teal-500 fill-current" />
          </div>
          <span className="ml-3 text-neutral-500 my-auto font-medium">
            {report.description}
          </span>
        </div>
      ))}
      {openModal.value && (
        <ModalReport
          open={openModal}
          layout={currentReport.value}
          onClose={closeModal}
          size="h-5/6 w-1/2"
        />
      )}
    </div>
  );
}

export default Reports;
